import { combineReducers } from 'redux'

import { reducers as loadMenuDataReducers } from './loadMenuDataReducers'
import { connectRouter } from 'connected-react-router'

const createReducers = (history) => combineReducers({
  loadMenuDataReducers,
  router: connectRouter(history)
})

export { createReducers }
